// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as PartnerScoreAssetConfig from "../../assets/PartnerScoreAssetConfig.bs.js";
import * as PartnerScoreV2CssHelper from "../../../domain/helper/PartnerScoreV2CssHelper.bs.js";

function ScoreSliderPinV2(Props) {
  var current_score = Props.current_score;
  var val = Props.val;
  var max_score = Props.max_score;
  return React.createElement("div", {
              className: "slider-pin-container-v2",
              style: {
                left: PartnerScoreV2CssHelper.getSliderPinPosition(current_score, max_score)
              }
            }, React.createElement("div", {
                  className: "slider-pin-line-v2",
                  style: {
                    height: val
                  }
                }), React.createElement("img", {
                  className: "slider-pin-v2",
                  style: {
                    top: val
                  },
                  src: PartnerScoreAssetConfig.pin_icon
                }));
}

var make = ScoreSliderPinV2;

export {
  make ,
  
}
/* react Not a pure module */
